define('OutSystems/ClientRuntime/modules/Database/DatabaseTypeUtils',["require", "exports", "../../DataTypes", "../../Exceptions", "./DBDataType"], function (require, exports, DataTypes_1, Exceptions_1, DBDataType_1) {
    "use strict";
    var _a;
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.convertDataTypeToDBDataType = exports.typeDisplayName = exports.convertToModelDataType = exports.typeDefaultValue = exports.dataTypeToDBDataType = void 0;
    exports.dataTypeToDBDataType = (_a = {},
        _a[DataTypes_1.DataTypes.Integer] = DBDataType_1.default.INTEGER,
        _a[DataTypes_1.DataTypes.LongInteger] = DBDataType_1.default.LONGINTEGER,
        _a[DataTypes_1.DataTypes.Decimal] = DBDataType_1.default.DECIMAL,
        _a[DataTypes_1.DataTypes.Currency] = DBDataType_1.default.DECIMAL,
        _a[DataTypes_1.DataTypes.Text] = DBDataType_1.default.TEXT,
        _a[DataTypes_1.DataTypes.PhoneNumber] = DBDataType_1.default.TEXT,
        _a[DataTypes_1.DataTypes.Email] = DBDataType_1.default.TEXT,
        _a[DataTypes_1.DataTypes.Boolean] = DBDataType_1.default.BOOLEAN,
        _a[DataTypes_1.DataTypes.Date] = DBDataType_1.default.DATE,
        _a[DataTypes_1.DataTypes.DateTime] = DBDataType_1.default.DATE_TIME,
        _a[DataTypes_1.DataTypes.Time] = DBDataType_1.default.TIME,
        _a[DataTypes_1.DataTypes.Record] = DBDataType_1.default.UNKNOWN,
        _a[DataTypes_1.DataTypes.RecordList] = DBDataType_1.default.UNKNOWN,
        _a[DataTypes_1.DataTypes.BinaryData] = DBDataType_1.default.BINARY_DATA,
        _a[DataTypes_1.DataTypes.Object] = DBDataType_1.default.UNKNOWN,
        _a);
    function typeDefaultValue(dataType) {
        switch (dataType) {
            case DBDataType_1.default.INTEGER:
            case DBDataType_1.default.LONGINTEGER:
            case DBDataType_1.default.DECIMAL:
            case DBDataType_1.default.TEXT:
            case DBDataType_1.default.BOOLEAN:
            case DBDataType_1.default.DATE:
            case DBDataType_1.default.DATE_TIME:
            case DBDataType_1.default.TIME:
            case DBDataType_1.default.BINARY_DATA:
                return DataTypes_1.defaultForType(convertToModelDataType(dataType));
            default:
                throw new Exceptions_1.Exceptions.DataBaseException("", "Unable to determine default value for type " + typeDisplayName(dataType));
        }
    }
    exports.typeDefaultValue = typeDefaultValue;
    function convertToModelDataType(dbDataType) {
        switch (dbDataType) {
            case DBDataType_1.default.TEXT:
                return DataTypes_1.DataTypes.Text;
            case DBDataType_1.default.BINARY_DATA:
                return DataTypes_1.DataTypes.BinaryData;
            case DBDataType_1.default.BOOLEAN:
                return DataTypes_1.DataTypes.Boolean;
            case DBDataType_1.default.DATE:
                return DataTypes_1.DataTypes.Date;
            case DBDataType_1.default.DATE_TIME:
                return DataTypes_1.DataTypes.DateTime;
            case DBDataType_1.default.TIME:
                return DataTypes_1.DataTypes.Time;
            case DBDataType_1.default.DECIMAL:
                return DataTypes_1.DataTypes.Decimal;
            case DBDataType_1.default.INTEGER:
                return DataTypes_1.DataTypes.Integer;
            case DBDataType_1.default.LONGINTEGER:
                return DataTypes_1.DataTypes.LongInteger;
            default:
                throw new Error("Missing case for conversion of DB data type '" + dbDataType + "' to a model data type.");
        }
    }
    exports.convertToModelDataType = convertToModelDataType;
    function typeDisplayName(dbDataType) {
        var modelDataType = convertToModelDataType(dbDataType);
        return DataTypes_1.DataTypes[modelDataType];
    }
    exports.typeDisplayName = typeDisplayName;
    function convertDataTypeToDBDataType(runtimeType) {
        var dbType = exports.dataTypeToDBDataType[runtimeType];
        return dbType !== null && dbType !== void 0 ? dbType : DBDataType_1.default.UNKNOWN;
    }
    exports.convertDataTypeToDBDataType = convertDataTypeToDBDataType;
});
//# sourceMappingURL=DatabaseTypeUtils.js.map;
